import { PATTERNS } from '../../constants/validations';
import { defaultValidator } from './defaultValidator';

export default value => !value || defaultValidator(PATTERNS.USERNAME, value);



// WEBPACK FOOTER //
// ./src/utils/validations/usernameValidator.js